import React, {Component} from "react";
import {NavLink} from "react-router-dom";

export default class WelcomeBox extends Component {
	render() {
		return <div className="columns login-box">
			<div className="column">
				<div className="columns is-centered">
					<div className="column is-10">
						<p className="is-size-5 has-text-centered">¡Hola {this.props.userLogin.name}!</p>

						<div className="columns is-multiline">
							<div className="column is-10 is-offset-1">
								<NavLink to={'/inicio'} className="button is-inm-purple" style={{margin: '30px auto 0 auto', display: 'block'}}>
									<span>Ingresar a e-trans</span>
									<span className="icon is-small"><i className="fa fa-sign-in"></i></span>
								</NavLink>
							</div>
							<div className="column is-10 is-offset-1 has-text-centered">
								<NavLink to="/logout" className="link is-black">Cambiar usuario</NavLink>
							</div>
						</div>
					</div>
				</div>
			</div>

			<a className="login-box--notification" href="http://etransversalidad2-0.inmujeres.gob.mx/" target="_blank">
				Acceder a versión 2020 <i className="fa fa-external-link" />
			</a>
		</div>
	}
}


// WEBPACK FOOTER //
// ./src/elements/login/welcome.jsx